import { useParams } from 'react-router-dom';
import { useGetPatientQuery } from '~/store/services/patients';
import PatientMedicationsTab from '~/components/maud/patients/profile/tabs/medications';

const MedicationsPage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const { data: patient } = useGetPatientQuery({ patientId });

  if (!patient) return null;

  return <PatientMedicationsTab patient={patient} />;
};

export default MedicationsPage;
